import React from 'react'
import CircleIcon from '@mui/icons-material/Circle';
import wideview from '../../../Assets/Images/wideView.svg'
import user from '../../../Assets/Images/user-engagement.svg'
import Likert from '../../Charts/Likert/Likert'
import { surveys } from '../../../utils/surveys';


const Engagements = () => {
  const left_labels = [
    { label: 0, color: '#E0510D' },
    { label: 1, color: '#F48956' },
    { label: 2, color: '#F8C9B4' },
  ];
  const right_labels = [
    { label: 3, color: '#DDEBA9' },
    { label: 4, color: '#ACC549' },
    { label: 5, color: '#7D8704' },
  ];
  const left_labels_no = [
    {label: 0, color: "#F48956" }
  ]
  const right_labels_yes = [
    {label:1, color: '#ACC549'}
  ]

  // const engagements = [
  //   {
  //     id: '#4.1',
  //     heading: 'Work related prayers',
  //     sub_heading: 'I am satisfied with my work',
  //     responses: {
  //       total: 100,
  //       data: {
  //         0: 9,
  //         1: 20,
  //         2: 11,
  //         3: 20,
  //         4: 35,
  //         5: 5
  //       }
  //     },
  //     responses2: {
  //       total: 100,
  //       data: {
  //         0: 51,
  //         1: 49
  //       }
  //     },
  //     UnmetInterest: 18,
  //   },
  //   {
  //     id: '#4.2',
  //     heading: 'SERVES OTHERS',
  //     sub_heading: 'I clearly see how my work serves others',
  //     responses: {
  //       total: 100,
  //       data: {
  //         0: 2,
  //         1: 11,
  //         2: 13,
  //         3: 14,
  //         4: 35,
  //         5: 25
  //       }
  //     },
  //     responses2: {
  //       total: 100,
  //       data: {
  //         0: 75,
  //         1: 25
  //       }
  //     },
  //     UnmetInterest: 24,
  //   },
  //   {
  //     id: '#4.3',
  //     heading: 'SERVES GOD',
  //     sub_heading: 'I clearly see how my work serves God',
  //     responses: {
  //       total: 100,
  //       data: {
  //         0: 9,
  //         1: 20,
  //         2: 11,
  //         3: 20,
  //         4: 35,
  //         5: 5
  //       }
  //     },
  //     responses2: {
  //       total: 100,
  //       data: {
  //         0: 40,
  //         1: 60
  //       }
  //     },
  //     UnmetInterest: 28,
  //   },
  //   {
  //     id: '#4.4',
  //     heading: 'POSITIVE EFFECT ON THE WORLD',
  //     sub_heading: 'I believe my work has a positive effect on the world',
  //     responses: {
  //       total: 100,
  //       data: {
  //         0: 90,
  //         1: 3,
  //         2: 2,
  //         3: 2,
  //         4: 2,
  //         5: 20
  //       }
  //     },
  //     responses2: {
  //       total: 100,
  //       data: {
  //         0: 67,
  //         1: 33
  //       }
  //     },
  //     UnmetInterest: 6,
  //   },
  //   {
  //     id: '#4.5',
  //     heading: 'COMFORT IDENTIFYING AS CHRISTIAN',
  //     sub_heading: 'I feel comfortable identifying as a Christian',
  //     responses: {
  //       total: 100,
  //       data: {
  //         0: 0,
  //         1: 1,
  //         2: 0,
  //         3: 33,
  //         4: 33,
  //         5: 33
  //       }
  //     },
  //     responses2: {
  //       total: 100,
  //       data: {
  //         0: 51,
  //         1: 49
  //       }
  //     },
  //     UnmetInterest: 15,
  //   }
  // ];

  const getAverageColor = (average) => {
    switch (Math.floor(average)) {
      case 0: return { background: "#E0510D", color: "#ffffff" }
      case 1: return { background: "#F48956", color: "#000000" }
      case 2: return { background: "#F8C9B4", color: "#000000" }
      case 3: return { background: "#DDEBA9", color: "#000000" }
      case 4: return { background: "#ACC549", color: "#ffffff" }
      case 5: return { background: "#7D8704", color: "#ffffff" }
      default: return { background: "#ffffff", color: "#000000" }
    }
  };

  const mapChurchEngagements = (surveys) => {
    const engagementIds = ['4.1', '4.2', '4.3', '4.4', '4.5', '4.6', '4.7'];
    const engagementHeadings = [ 'WORK RELATED PRAYERS', 'HELPFUL WORK SERMONS', 'WORKPLACE VISIT', 'PASTORAL GUIDANCE', 'RESOURCES', 'MEANINGFUL CONVERSATONS', 'CHURCH CONNECTIONS' ];
    const engagementSubHeadings = [ "I've heard my pastor pray for my work, workplace, or industry", "I've heard sermons that are helpful to me as a worker", "My pastor has visited me at my workplace", "I've received pastoral guidance related to my work", "I've received resources from my church about applying my faith to my work", "I've had a meaningful conversation with someone in the church about my work", "My church has connected me with similar workers in my industry" ];
  
    return engagementIds.map((id, index) => {
      const interestData = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      const historyData = { 0: 0, 1: 0 };
      let unmetInterest = 0;
      
      surveys.forEach(survey => {
        if (survey.church_engagements && survey.church_engagements.rating[id]) {
          const interest = Math.floor(survey.church_engagements.rating[id].interest);
          const history = Math.floor(survey.church_engagements.rating[id].history);
          interestData[interest] += 1;
          historyData[history > 0 ? 1 : 0] += 1;
          
          if (interest < 3) {
            unmetInterest += 1;
          }
        }
      });
      
      const totalInterestResponses = Object.values(interestData).reduce((acc, count) => acc + count, 0);
      const totalHistoryResponses = Object.values(historyData).reduce((acc, count) => acc + count, 0);
  
      return {
        id: `#${id}`,
        heading: engagementHeadings[index],
        sub_heading: engagementSubHeadings[index],
        responses: {
          total: totalInterestResponses,
          data: interestData
        },
        responses2: {
          total: totalHistoryResponses,
          data: historyData
        },
        UnmetInterest: unmetInterest
      };
    });
  };

  const engagements = mapChurchEngagements(surveys);

  return (
    <div className='engagement'>
      <div className="data">
        <div className="engagement-head">
          <p className='col0'>Engagement</p>
          <div className='graph-container'>
            <div className='col1'>
              <p>Last 12 MO.</p>
              <div className='col1-desc'>
                <div className='no'>
                  <CircleIcon sx={{ fontSize: "12px", color: "#F48956" }} />
                  <p>No</p>
                </div>
                <div className='yes'>
                  <CircleIcon sx={{ fontSize: "12px", color: "#ACC549" }} />
                  <p>Yes</p>
                </div>
              </div>
            </div>
            <div className='col2'>
              <p>Future Interest</p>
              <div className='col2-desc'>
                <div className='no'>
                  <CircleIcon sx={{ fontSize: "12px", color: "#E0510D" }} />
                  <p>0</p>
                  <CircleIcon sx={{ fontSize: "12px", color: "#F48956" }} />
                  <p>1</p>
                  <CircleIcon sx={{ fontSize: "12px", color: "#F8C9B4" }} />
                  <p>2</p>
                </div>
                <div className='yes'>
                  <CircleIcon sx={{ fontSize: "12px", color: "#DDEBA9" }} />
                  <p>3</p>
                  <CircleIcon sx={{ fontSize: "12px", color: "#ACC549" }} />
                  <p>4</p>
                  <CircleIcon sx={{ fontSize: "12px", color: "#7D8704" }} />
                  <p>5</p>
                </div>
              </div>
            </div>
            <div className='col3'>
              <p className='last-col'>UNMET <br /> INTEREST</p>
            </div>
          </div>
        </div>
        {engagements.map((engagement, i) =>
          <div className="row" key={i}>
            <div className="serial-no">{engagement.id}</div>
            <div className="text">
              <div className="heading">{engagement.heading}</div>
              <div className="sub-heading">{engagement.sub_heading}</div>
            </div>
            <div className='graph-columns'>
              <div className="likert-column">
                <Likert left_labels={left_labels_no} right_labels={right_labels_yes} responses={engagement.responses2} />
              </div>
              <div className="likert-column">
                <Likert left_labels={left_labels} right_labels={right_labels} responses={engagement.responses} />
              </div>
            <div className="unset-user"> <img src={user} alt="" /> {engagement.UnmetInterest}</div>
            </div>
            <div className="expand">
              <img src={wideview} alt="" />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Engagements
